import React from 'react';
import './styles.css';
export var Header = function () {
    return (React.createElement("div", { className: 'header' },
        React.createElement("h1", null, "React TypeScript Starter"),
        React.createElement("iframe", { src: 'https://ghbtns.com/github-btn.html?user=hhimanshu&repo=create-react-ts-starter&type=star&count=true&size=large', frameBorder: '0', scrolling: '0', width: '170', height: '30', title: 'GitHub' })));
};
